import { Grid, Typography } from '@mui/material';

function VideoText(props) {
  return (
    <Grid
      container
      alignItems={'start'}
      justifyContent={'start'}
      width={'100%'}
      style={{ marginTop: '7px' }}
    >
      <Grid item md={5}>
        <Grid container >
          <Grid item md={1}>
            <img alt="" src={props.icon} style={{ width: '16px', marginTop: '2px' }}></img>
          </Grid>
          <Grid item md={9} style={{ marginLeft: '5px' }}>
            <Typography style={{ fontWeight: '600', fontSize: '16px' }}>
              {props.paragraphHeading}
            </Typography>
          </Grid>
          <Grid item md={1}>
            {props.paragraph ? <Typography>-</Typography> : ''}
          </Grid>
        </Grid>
      </Grid>
      <Grid item md={7}>
        <Typography style={{ fontSize: '16px'}}>{props.paragraph}</Typography>
      </Grid>
    </Grid>
  );
}

export default VideoText;
